import React, { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import styles from './SignSelf.module.css';
import tabsStyles from '../settings/settings.module.css';
import CustomTable from '../../component/customTable/CustomTable';
import AppHeader from '../../component/appHeader/AppHeader';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { Box, debounce, useMediaQuery } from '@mui/material';
import { toggleLoader } from '../../store/loader/loaderReducer';
import { Navigation } from '../../utils/handleNavigation';
import { toast } from 'react-toastify';
import { signId_action } from '../../store/signIDDetails/signId_action';
import { getTemplatePreview } from '../../Api/TemplatePreviewApi';
import { getPDFDownload } from '../../Api/PDFDownloadApi';
import Skeleton from '@mui/material/Skeleton';
import MobileView from '../../component/MobileView';
import DocumentViewModal from '../../component/DocumentViewModal';

const tHead = ['Template Name', 'Status', 'Source', 'Receiver', 'Created Time'];
const keys = ['Template_Name', 'Status', 'source_name', 'Email_Id', 'Created_Time'];

const tHeadNeed = ['Template Name', 'Created By', 'Created Time', 'Expiry Date', 'My Status', 'Document Status'];
const keysNeed = ['Template_Name', 'created_by_name', 'created_time', 'expiry_date', 'my_status', 'document_status'];

const signStatusMap = {
  0: { status: 'Declined', color: '#F72222' },
  1: { status: 'Sent', color: ' #2C47CB' },
  2: { status: 'Progress', color: '#AB6BFF' },
  3: { status: 'Completed', color: ' #23AB94' },
  4: { status: 'Declined', color: '#F72222' },
  5: { status: 'Expired', color: '#F38435' },
  6:{ status: 'Draft', color: ' #F5CA99' },
  7: { status: 'Viewed', color: ' #AB6BFF' },
  8: { status: 'Recall', color: ' #56BAE1' },
};
const signStatus = {
  0: { status: 'Declined', color: '#F72222' },
  1: { status: 'Sent', color: ' #2C47CB' },
  2: { status: 'Progress', color: '#AB6BFF' },
  3: { status: 'Completed', color: ' #23AB94' },
  4: { status: 'Declined', color: '#F72222' },
  5: { status: 'Expired', color: '#F38435' },
  // 6: { status: 'Draft', color: ' #F5CA99' },
  7: { status: 'Viewed', color: ' #AB6BFF' },
  8: { status: 'Recall', color: ' #56BAE1' },
};

const SignSelf = () => {
  const dispatch = useDispatch();
  const navPath = Navigation();
  const mobile_view = useMediaQuery('(min-width: 600px)');
  const statusOptions = useMemo(() => Object.entries(signStatus).map(([id, s]) => ({ value: Number(id), label: s.status })), []);

  const [activeTab, setActiveTab] = useState(() => {
    const s = typeof window !== 'undefined' ? window.localStorage.getItem('signSelfActiveTab') : null;
    return s === 'All' ? 'All' : 'My Sign Requests';
  });
  const tabs = useMemo(() => ["My Sign Requests", "All"], []);
  const [loading, setLoading] = useState(false);

  const document = useSelector((state) => state?.document?.value);
  const show_integeration = useSelector((state) => state.welcomeImgDetail.value);
  const admin = show_integeration?.user_information?.userRole.includes('Super Admin', 'Admin');


  const [checkedId, setCheckedId] = useState([]);
  const [selfSignDetails, setSelfSignDetails] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pageShow, setPageShow] = useState(false);
  const [pageIndex, setPageIndex] = useState(false);
  const [page_idx, setPage_idx] = useState(0);
  const [page_size, setPage_size] = useState(10);
  const [mobileView, setMobileView] = useState(false);
  const [needSignDetails, setNeedSignDetails] = useState([]);
  const [needTotalRecord, setNeedTotalRecord] = useState(0);
  const [needPageIdx, setNeedPageIdx] = useState(0);
  const [needPageSize, setNeedPageSize] = useState(10);
  const [needCheckedId, setNeedCheckedId] = useState([]);
  const [statusFilterSelf, setStatusFilterSelf] = useState('');
  const [statusFilterAll, setStatusFilterAll] = useState('');
  const [file, setFile] = useState(null);

  
  const handleNeedSignRequest = (idx = 0, size = 10, val) => {
    dispatch(toggleLoader(true));
    setLoading(true);

    axios.get(process.env.REACT_APP_MY_SIGN_REQUEST, {
      params: {
        org_id: document?.OrgId,
        limit: size ?? 10,
        ...(idx > 0 ? { cursor: idx + 1 } : { cursor: 1 }),
        ...(val ? { search: val } : {}),
      },
      withCredentials: process.env.REACT_APP_CREDENTIALS,
    })
      .then((res) => {
        const list = res?.data?.response?.recipients || res?.data?.response || res?.data?.need_your_sign_list || res?.data?.sign_for_myself_list || [];
        const data = (Array.isArray(list) ? list : []).map((o) => {
          const docStatusVal = o?.document_status ?? o?.status ?? o?.Status;
          const myStatusVal = o?.my_status;
          const docStatusMeta = typeof docStatusVal === 'number' && signStatusMap.hasOwnProperty(docStatusVal) ? signStatusMap[docStatusVal] : null;
          const myStatusMeta = typeof myStatusVal === 'number' && signStatusMap.hasOwnProperty(myStatusVal) ? signStatusMap[myStatusVal] : null;

          const formatDate = (v) => {
            if (v === undefined || v === null || v === 0 || v === '0') return '—';
            const n = Number(v);
            if (!Number.isNaN(n)) {
              const ms = n > 1e12 ? n : n * 1000;
              return dayjs(ms).format('DD-MM-YYYY hh:mm A');
            }
            if (typeof v === 'string') return v;
            return '—';
          };

          const documentStatusEl = (
            <Box style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <Box
                className={styles.custom_dot}
                style={{ backgroundColor: docStatusMeta?.color || '#AB6BFF' }}
              ></Box>
              {docStatusMeta?.status || (typeof docStatusVal === 'string' ? docStatusVal : 'N/A')}
            </Box>
          );

          const myStatusEl = (
            <Box style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <Box
                className={styles.custom_dot}
                style={{ backgroundColor: myStatusMeta?.color || '#AB6BFF' }}
              ></Box>
              {myStatusMeta?.status || (typeof myStatusVal === 'string' ? myStatusVal : 'N/A')}
            </Box>
          );

          return {
            ...o,
            Name: o?.name || o?.Contact_Name || o?.ContactName || o?.Name || '—',
            Sign_Id: o?.sign_id ?? o?.Sign_Id ?? o?.Id ?? '-',
            Template_Name: o?.template_name || '—',
            Email_Id: o?.email_id || o?.Email_Id || o?.Recipient_Email || o?.Email || '—',
            created_by_name: o?.created_by_name || '—',
            created_time: formatDate(o?.created_time),
            expiry_date: formatDate(o?.expiry_date),
            my_status: myStatusEl,
            document_status: documentStatusEl,
            statustype: myStatusVal,
          };
        });

        setNeedSignDetails(data);
        if (idx === 0) {
          setNeedTotalRecord(res?.data?.total_record ?? res?.data?.response?.total_records ?? data.length);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error(err?.message || 'Failed');
      })
      .finally(() => {
        setLoading(false);
        dispatch(toggleLoader(false));
      });
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === "All") handleNeedSignRequest(0, 10);
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('signSelfActiveTab', activeTab);
    }
  }, [activeTab]);

  const handleNeedRowClick = (val) => {

    const statusCode = val?.statustype;
    if (statusCode === 3) {
      const fileId = val?.Id ?? val?.Sign_Id ?? val?.sign_id;
      // handleView(fileId, val?.Org_Id ?? document?.OrgId);
      return;
    }

    const digest = val?.digest ?? val?.Digest;
    if (digest) {
      window.open(`${process.env.REACT_APP_URL}/#/sign-request?digest=${encodeURIComponent(digest)}`,'_blank');
    } else {
      toast.error('Digest not available');
    }
  };

  const filteredSelfSignDetails = useMemo(() => {
    if (statusFilterSelf === '' || statusFilterSelf === undefined || statusFilterSelf === null) return selfSignDetails;
    return selfSignDetails.filter((row) => {
      const v = row?.statustype;
      if (typeof v === 'number') return v === statusFilterSelf;
      if (typeof v === 'string') return false;
      return false;
    });
  }, [selfSignDetails, statusFilterSelf]);

  const filteredNeedSignDetails = useMemo(() => {
    if (statusFilterAll === '' || statusFilterAll === undefined || statusFilterAll === null) return needSignDetails;
    return needSignDetails.filter((row) => {
      const v = row?.statustype;
      if (typeof v === 'number') return v === statusFilterAll;
      if (typeof v === 'string') return false;
      return false;
    });
  }, [needSignDetails, statusFilterAll]);

  useEffect(() => {
    if (activeTab === 'All') {
      handleNeedSignRequest(0, 10);
    } else {
      fetchSignMySelf();
    }
  }, []);

  const fetchSignMySelf = (idx = 0, size = 10, val, key) => {
    dispatch(toggleLoader(true));
    axios.get(process.env.REACT_APP_SIGNMYSELF, {
      params: {
        org_id: document?.OrgId,
        limit: size ?? 10,
        ...(idx > 0 ? { cursor: key ? idx : idx + 1 } : { cursor: 1 }),
        ...(val?.length > 0 ? { search: val } : {}),
      }, withCredentials: process.env.REACT_APP_CREDENTIALS
    })
      .then((res) => {
        const data = res.data.sign_for_myself_list.map((o) => {
          const { Status, Modified_Time, Created_Time, ...restData } = o;

          const statusEl = (
            <Box style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <Box
                className={styles.custom_dot}
                style={{ backgroundColor: signStatusMap[Status]?.color }}
              ></Box>
              {signStatusMap[Status]?.status}
            </Box>
          );

          return {
            ...restData,
            Modified_Time: Modified_Time,
            Created_Time: Created_Time,
            Status: statusEl,
            statustype: Status,
          };
        });
        setSelfSignDetails(data);

        if (idx === 0) {
          setTotalRecord(res.data.total_record);
        }
        setPageShow(true);

        dispatch(toggleLoader(false));
      })
      .catch((err) => {
        toast.error(err.message);
        dispatch(toggleLoader(false))

      });
    // .finally(() => dispatch(toggleLoader(false)));
  };

  const debouncedSendRequest = debounce(fetchSignMySelf, 800);

  const debouncedNeedRequest = debounce(handleNeedSignRequest, 800);

  const handleSearch = (idx = 0, size = 10, val) => {
    const encode = encodeURIComponent(val);
    debouncedSendRequest(idx = 0, size = 10, encode);
  };

  const handleView = (fileId, orgId) => {
    if (!fileId) {
      toast.error('Invalid document');
      return;
    }
    dispatch(toggleLoader(true));
    const data = { sign_id: fileId, Org_Id: orgId || document?.OrgId, type: 2 };
    getPDFDownload(
      data,
      (res) => {
        setFile(res.data);
        dispatch(toggleLoader(false));
      },
      (e) => {
        toast.error(e.message);
        dispatch(toggleLoader(false));
      }
    );
  };

  const deleteSignMySelf = (_id, resetId = () => { }, pageSize, cursor) => {
    dispatch(toggleLoader(true));
    const id = _id ? [_id] : checkedId;

    let data = JSON.stringify({
      org_id: document?.OrgId,
      ids: id,
      limit: pageSize,
      cursor: cursor,
    });

    const headers = {
      'Content-Type': 'application/json',
    };

    axios.delete(process.env.REACT_APP_SIGNMYSELF, { headers: headers, data: data, withCredentials: process.env.REACT_APP_CREDENTIALS })
      .then((res) => {
        resetId();
        const data = res.data.sign_for_myself_list.map((o) => {
          const { Status, Modified_Time, Created_Time, ...restData } = o;

          const statusEl = (
            <Box style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <Box
                className={styles.custom_dot}
                style={{ backgroundColor: signStatusMap[Status]?.color }}
              ></Box>
              {signStatusMap[Status]?.status}
            </Box>
          );

          return {
            ...restData,
            Modified_Time: Modified_Time,
            Created_Time: Created_Time,
            Status: statusEl,
            statustype: Status,
          };
        });

        if (data?.length) {
          setSelfSignDetails(data);
        } else {
          fetchSignMySelf(cursor - 1, pageSize, null, 'delete');
          setPageIndex(true);
        }
        setTotalRecord(totalRecord - id?.length);
        setPageShow(true);
        dispatch(toggleLoader(false));
        toast.success('Success');
      })
      .catch((err) => {
        toast.error(err.message);
        dispatch(toggleLoader(false))

      })
      .finally(() => dispatch(toggleLoader(false)));
  };

  const convertKeysToLowerCase = (obj) => {
    const newObj = {};
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const lowerCaseKey = key.toLowerCase();
        newObj[lowerCaseKey] = obj[key];
      }
    }
    return newObj;
  };

  const handleSignClick = (id) => {
    if (signStatusMap[id?.statustype]?.status === 'Draft') {
      if (mobile_view) {
        dispatch(toggleLoader(true));
        dispatch(signId_action(null));
        getTemplatePreview(id, dispatch, (res) => {
          let data = res.data;
          const newObj = convertKeysToLowerCase(id);
          dispatch(signId_action(newObj));
          navPath(`/sign-myself/${data.template_information.Id}?id=${id?.Id}&action=draft`, 'document_reload');
        }, (err) => {
          toast.error(err.message);
          dispatch(toggleLoader(false));
        });
      } else {
        setMobileView(true);
      }
    } else {
      navPath(`/sign-myself-details/${id?.Id}`);
      dispatch(toggleLoader(true));
    }
  };

  return (
    <>
      <div className={tabsStyles.tabs}>
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`${tabsStyles.tab} ${activeTab === tab ? tabsStyles.active : ""}`}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </div>
        ))}
      </div>
      <Box className={tabsStyles.tab_content}>
      {activeTab === "My Sign Requests" && (
        <>
      {pageShow ? (
        <Box className={styles.main_wrap}>
          <>
            {/* {show_integeration?.user_permission[4].create === 1 && */}
            <AppHeader
              btnText='Upload'
              moduleText='My Sign Requests'
              // onBtnClick={() => navPath('/upload')}
               onBtnClick={() => navPath('/upload', {  id: 4  })}
              checkAdmin={admin}
              rolePermissions={show_integeration?.user_permission[1]}
            />
            {/* } */}
            <CustomTable
              getPageIndexSize={({ pageIdx, pageSize }) => {
                setPage_idx(pageIdx);
                setPage_size(pageSize);
                fetchSignMySelf(pageIdx, pageSize);
              }}
              onSearch={({ pageIdx, pageSize, value }) =>
                handleSearch(0, pageSize, value)
              }
              page_idx={page_idx}
              page_size={page_size}
              totalRecordCount={totalRecord}
              pageDeleteIndex={pageIndex}
              pageSetIndex={(val) => setPageIndex(val)}
              searchName='Search Sign Request'
              keys={keys}
              head={tHead}
              body={selfSignDetails}
              onDelete={deleteSignMySelf}
              getCheckedId={setCheckedId}
              onRowClick={(val) => {
                (admin || (show_integeration?.user_permission[4]?.update === 1 || show_integeration?.user_permission[4]?.read === 1)) && handleSignClick(val)
              }}
              checkAdmin={admin}
              rolePermissions={show_integeration?.user_permission[4]}
            />
          </>
          <MobileView mobileView={mobileView} closeMobileView={() => setMobileView(false)} />
        </Box>
      ) : 
      <Skeleton sx={{ bgcolor: 'rgba(189,197,209,.2)', margin: '10px' }} animation="wave" variant="rounded" width={'calc(100% - 20px)'} height={'calc(100vh - 80px)'} />}
      </>
      )}
      {activeTab === "All" && (
        <Box className={styles.main_wrap}>
          <CustomTable
            getPageIndexSize={({ pageIdx, pageSize }) => {
              setNeedPageIdx(pageIdx);
              setNeedPageSize(pageSize);
              handleNeedSignRequest(pageIdx, pageSize);
            }}
            onSearch={({ pageIdx, pageSize, value }) =>
              debouncedNeedRequest(0, pageSize, value)
            }
            page_idx={needPageIdx}
            page_size={needPageSize}
            totalRecordCount={needTotalRecord}
            searchName='Search Sign Request'
            keys={keysNeed}
            head={tHeadNeed}
            body={filteredNeedSignDetails}
            getCheckedId={setNeedCheckedId}
            onRowClick={(val) => handleNeedRowClick(val)}
            onDelete={deleteSignMySelf}
            rolePermissions={show_integeration?.user_permission?.[3] || show_integeration?.user_permission?.[4] || {}}
            statusFilterOptions={statusOptions}
            statusFilterValue={statusFilterAll}
            onStatusFilterChange={(val) => setStatusFilterAll(val === '' ? '' : (typeof val === 'string' ? Number(val) : val))}
          />
          <DocumentViewModal file={file} setFile={(value) => setFile(value)} />
        </Box>
      )}
      </Box>
    </>
  );
};

export default SignSelf;
